import { ICollaboration } from '@descomplica/microfrontend-core';
import { injectable } from 'tsyringe';

import { CollaborationResult } from '@/infrastructure/gateways/classroom/models/collaboration-result';
import { Lesson, Video } from '@/presentation/screens/classroom/classroom.vm';

import {
  CurrentVideoNotFound,
  CurrentVideoUnexpectedError,
  ObtainedCurrentVideo,
} from './get-current-video-on-lessons.collaboration.responses';

interface Params {
  lesson?: Lesson;
  currentVideoGuid?: string;
}

@injectable()
export class GetCurrentVideoOnLessonsCollaboration
  implements ICollaboration<Params, Promise<CollaborationResult<Video | undefined>>>
{
  async run({ lesson, currentVideoGuid }: Params): Promise<CollaborationResult<Video | undefined>> {
    try {
      if (!lesson) {
        return new CurrentVideoNotFound();
      }

      const currentVideo =
        (lesson?.videos?.find((v) => v.guid === currentVideoGuid) as Video) ||
        (lesson?.videos?.[0] as Video);

      return new ObtainedCurrentVideo(currentVideo);
    } catch (e) {
      return new CurrentVideoUnexpectedError();
    }
  }
}
